export enum Environment {
  development = "development",
  uat = "uat",
  production = "production",
}

export enum Page {
  applicationForLeave = "applicationForLeave",
  monthlyTrainingPlan = "monthlyTrainingPlan",
  monthlyTrainingPlanSummary = "monthlyTrainingPlanSummary",
  businessCard = "businessCard",
}

export const BASE_DEVELOPMENT_URL = "https://viags-dev.azurewebsites.net";
export const BASE_UAT_URL = "https://viags-dev.azurewebsites.net";
export const BASE_PRODUCTION_URL = "https://viags.azurewebsites.net";
export const BATCHING_URL = "https://graph.microsoft.com/v1.0/$batch";
export const sendMailTriggerUrl =
  "https://prod-40.southeastasia.logic.azure.com:443/workflows/bbe83d97849648dea374cf687c1bda53/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=zXUL2Zr8h5RT_QgV8E7xlrH03F9lOwldrghYwbAIzqY";

const ENVIRONMENT = process.env["REACT_APP_ENV"] as Environment;

const getBaseURL = (env: string): string => {
  switch (env) {
    case Environment.development:
      return BASE_DEVELOPMENT_URL;
    case Environment.production:
      return BASE_PRODUCTION_URL;
    case Environment.uat:
      return BASE_UAT_URL;
    default:
      return BASE_DEVELOPMENT_URL;
  }
};

const getPageURL = (page: Page): string => {
  const baseURL = getBaseURL(ENVIRONMENT);
  switch (page) {
    case Page.applicationForLeave:
      return `${baseURL}/procedure/absence-letter`;
    case Page.monthlyTrainingPlan:
      return `${baseURL}/procedure/monthly-training-plan`;
    case Page.monthlyTrainingPlanSummary:
      return `${baseURL}/procedure/monthly-training-plan-summary`;
    case Page.businessCard:
      return `${baseURL}/procedure/business-card`;
    default:
      return "";
  }
};

// Page urls
export const APPLICATION_FOR_LEAVE_URL = getPageURL(Page.applicationForLeave);
export const MONTHLY_TRAINING_PLAN_URL = getPageURL(Page.monthlyTrainingPlan);
